import {isAuthenticated} from "../api/helper";

export const closeMenuMobile = () => {
  if (! isAuthenticated()) {
    document.body.classList.add('menu-closed');
    document.querySelector('.header').classList.remove('menu-open');

    setTimeout(() => {
      document.body.classList.remove('menu-open');
      document.body.classList.remove('menu-closed');
    }, 600);
  }
}
